export enum EnumMiniCrmInteractionType {
  SendEmail = 2,
  ReceivedEmail = 3,
  MeetingInPerson = 4,
  MeetingOnline = 5,
  PhoneCallSpoke = 6,
  PhoneCallLeftMessage = 7,
  Other = 8,
  MiscNote = 9
}

export const InteractionTypes = [
  { value: EnumMiniCrmInteractionType.SendEmail, text: "Send Email" },
  { value: EnumMiniCrmInteractionType.ReceivedEmail, text: "Received Email" },
  {
    value: EnumMiniCrmInteractionType.MeetingInPerson,
    text: "Meeting in Person",
  },
  { value: EnumMiniCrmInteractionType.MeetingOnline, text: "Online" },
  { value: EnumMiniCrmInteractionType.Other, text: "Meeting Other" },
  {
    value: EnumMiniCrmInteractionType.PhoneCallSpoke,
    text: "Phone Call, Spoke",
  },
  {
    value: EnumMiniCrmInteractionType.PhoneCallLeftMessage,
    text: "Phone Call, Left Message",
  },
  {
    value: EnumMiniCrmInteractionType.MiscNote,
    text: "Misc Note",
  },
];
